
<div class="progress-bar-container">
  <div :class="['bar', variant]" :style="`width: ${percentageLimited}%;`"></div>
</div>
